import { format } from 'date-fns';
import { formatRelative } from '../groupings';

function deriveTimeline(listing) {
    const v5 = listing._v5Status;
    const submitted = listing.submittedAt
        ? formatRelative(listing.submittedAt)
        : 'Recently';
    const enriched = listing.enrichmentCompletedAt
        ? format(new Date(listing.enrichmentCompletedAt), 'MMM d')
        : 'Pending';

    if (v5 === 'live') {
        return [
            { state: 'done', title: 'Submitted', meta: submitted },
            { state: 'done', title: 'AI enrichment', meta: enriched },
            { state: 'done', title: 'Approved by Ops', meta: listing.reviewedAt ? format(new Date(listing.reviewedAt), 'MMM d') : '—' },
            { state: 'current', title: 'Live and bookable', meta: 'Earning since approval' },
        ];
    }

    if (v5 === 'review') {
        return [
            { state: 'done', title: 'Submitted', meta: submitted },
            { state: 'done', title: 'AI enrichment', meta: enriched },
            { state: 'current', title: 'In ops review', meta: 'Awaiting approval' },
        ];
    }

    if (v5 === 'attention') {
        return [
            { state: 'done', title: 'Submitted', meta: submitted },
            { state: 'done', title: 'AI enrichment', meta: enriched },
            { state: 'error', title: 'Ops review', meta: listing.reviewedAt ? format(new Date(listing.reviewedAt), 'MMM d') : 'Changes requested' },
            { state: 'current', title: 'Awaiting your edits', meta: 'Edit and resubmit to continue' },
        ];
    }

    if (v5 === 'bulk_draft') {
        return [
            { state: 'done', title: 'Uploaded via bulk CSV', meta: formatRelative(listing.createdAt) },
            { state: 'current', title: 'Bulk draft — needs your input', meta: 'Complete checklist items to submit' },
        ];
    }

    return [
        { state: 'current', title: 'Draft — incomplete', meta: `Last edited ${formatRelative(listing.updatedAt)}` },
    ];
}

export default function buildTimeline(listing) {
    return deriveTimeline(listing);
}
